import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { Particles } from "@tsparticles/react";
import { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";
import "swiper/css";
import "swiper/css/navigation";
import "./hero.css";

//import slider images
import img1 from "../../assets/images/Hero/ecommerce-development-company-banner-img.png"
import img2 from "../../assets/images/Hero/erp-crm-development-company-banner-img.png"
import img3 from "../../assets/images/Hero/mobile-app-development-company-banner-img.png"
import img4 from "../../assets/images/Hero/software-development-company-banner-img.png"
import img5 from "../../assets/images/Hero/web-development-company-bannre-img.png"
import { Link } from "react-router-dom";

const slides = [
  { title: "Ecommerce", description: "Development Company", image: img1 },
  { title: "ERP/CRM", description: "Development Company", image: img2 },
  { title: "Mobile App", description: "Development Company", image: img3 },
  { title: "Software", description: "Development Company", image: img4 },
  { title: "Web", description: "Development Company", image: img5 },
];

const ContentImageSwiper = () => {


  const prevRef = useRef(null);
  const nextRef = useRef(null);

  // ✅ initialize tsparticles engine
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine); // use "loadFull(engine)" if you want all effects
    });
  }, []);


  return (
    <div className="hero">
      {/* ✅ Particle Background */}
      <Particles
        id="tsparticles"
        options={{
          fullScreen: { enable: false },
          particles: {
            number: { value: 80, density: { enable: true, value_area: 800 } },
            color: { value: "#00aaff" },
            shape: { type: "circle" },
            opacity: { value: 0.6, random: true },
            size: { value: 3, random: true },
            move: { enable: true, speed: 1.5, outModes: "out" },
            links: { enable: true, color: "#00aaff", distance: 120, opacity: 0.4, width: 1 },
          },
          interactivity: {
            events: {
              onHover: { enable: true, mode: "repulse" },
              onClick: { enable: true, mode: "push" },
            },
            modes: {
              repulse: { distance: 100 },
              push: { quantity: 4 },
            },
          },
          retina_detect: true,
        }}
        className="particles-bg"
      />
      <div className="content-image-swiper">


        {/* ✅ Swiper */}
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          autoplay={{
            delay: 2000,            // 3 seconds
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }}
          loop
          slidesPerView={1}
          className="mySwiper"
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="slide-content">
                <div className="text-section">
                  <div className="text-inner">
                    <h2 className="slide-title">{slide.title}</h2>
                    <p className="slide-desc">{slide.description}</p>
                    <button className="quote-btn"><Link to="/get-a-quote">GET A QUOTE →</Link></button>
                  </div>
                </div>
                <div className="image-section">
                  <img src={slide.image} alt={slide.title} />
                </div>
              </div>

            </SwiperSlide>
          ))}

          <div className="custom-arrows">
            <button ref={prevRef} className="custom-prev">
              <i className="fas fa-chevron-up"></i>
            </button>
            <button ref={nextRef} className="custom-next">
              <i className="fas fa-chevron-down"></i>
            </button>
          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default ContentImageSwiper;
